import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, OnboardingProgress } from '@/types';

/**
 * LEGACY read shim.
 *
 * The step wizard is gone; its write endpoints now return 410, so only the
 * read survives here. Guide dashboard surfaces still call this for progress —
 * they should move to `guideProfileApi.getStatus()` so the server-side shim
 * can be retired.
 */
export const onboardingApi = {
  async getProgress(): Promise<OnboardingProgress> {
    const response = await apiClient.get<ApiResponse<OnboardingProgress>>('/onboarding/me');
    return response.data.data!;
  },
};

export const onboardingKeys = {
  all: ['onboarding'] as const,
  progress: (userId?: string | null) =>
    [...onboardingKeys.all, 'progress', userId ?? 'anonymous'] as const,
};

/** @deprecated Use onboardingApi from '@/features/onboarding/api/onboarding.api' */
export const onboardingService = onboardingApi;
